import _ from 'lodash';
import Immutable from 'seamless-immutable';

/**
 * Data Source Model
 * @typedef {Object} DataSource
 * @property {string[]} id -- data source item key
 * @property {string[]} name -- data source item value
 * @property {boolean} required -- predefined backend required field (initially shown in the wizard)
 * @property {boolean} mandatory -- predefined backend mandatory field (initially shown in the wizard and set to the mandatory Grow field)
 * @property {string[]} primaryKey -- backend technical field, that should be passed within the integration save/update request payload
 * @property {boolean} nonDeletable -- technical field to show/hide the delete buttons
 * @property {string} type -- data type of the mapping field

/**
 * Create a Data Source Model from provided data
 */
function create(dropdownItem = {}) {
  const result = _.clone(dropdownItem);
  return Immutable(result);
}

/**
 * Transforms a backend data source object into a frontend DataSourceModel
 * @param {Object} dropdownItem - backend formatted integration
 * @returns {Integration}
 */
function deserialize(dropdownItem) {
  const result = _.pick(dropdownItem, _keys);
  return create(result);
}

/**
 * Transform a DataSourcenModel into a backend integration object
 * @returns {Object}
 */
function serialize(dropdownItem) {
  const result = dropdownItem.asMutable({ deep: true });
  return _.pick(result, _keys);
}

const _keys = ['id', 'name', 'required', 'mandatory', 'primaryKey', 'nonDeletable', 'type'];

export default {
  create,
  deserialize,
  serialize,
};
